window.VGLeasingCalculator = {
	rangeInitialPayment: '#initial-payment',
	rangeLoanTerm: '#loan-term',
	rangeInitialPrice: '#initial-price',

	init: function ($container) {
		const _this = this;

		_this.getData($container);

		$container.find(_this.rangeInitialPrice).ionRangeSlider({
			skin: "round",
			onChange: function (data) {
				data.input.val(data.from);
				_this.getData($container);
			}
		})

		$container.find(_this.rangeInitialPayment).ionRangeSlider({
			skin: "round",
			onChange: function (data) {
				data.input.val(data.from);
				_this.getData($container);
			}
		})

		$container.find(_this.rangeLoanTerm).ionRangeSlider({
			skin: "round",
			onChange: function (data) {
				data.input.val(data.from);
				_this.getData($container);
			}
		})
	},

	getData: function ($container) {
		const _this = this;

		let data = {
			sum: parseFloat($container.find('[name="price"]').val()),
			percent: parseFloat($container.find('[name="percent"]').val()),
			initialPercent: parseFloat($container.find(_this.rangeInitialPayment).val()),
			loanTerm: parseFloat($container.find(_this.rangeLoanTerm).val()),
		}

		this.countAmountPayment(data, $container);
	},

	countAmountPayment: function (data, $container) {
		let sum = data.sum,
			initialPercent = data.initialPercent,
			percent = data.percent,
			loanTerm = data.loanTerm;

		// Считаем сумму кредита с учетом первоначального взноса
		let sumWithInitialPayment = sum - (sum * initialPercent / 100);

		// Считаем сумму кредита с учетом процентной ставки
		let sumWithPercent = sumWithInitialPayment + (sumWithInitialPayment * percent / 100);

		data.result = parseInt('' + sumWithPercent / loanTerm);
		data.sumWithInitialPayment = parseInt('' + (sum - sumWithInitialPayment));

		this.setData(data, $container);
	},

	setData: function (data, $container) {
		$container.find('#monthly-payment').text(output_roubles(data.result));
		$container.find('[name="monthly-payment"]').val(data.result);

		let $resultArea = $container.find('.leasing-calculator-result');
		$resultArea.find('[data-sum]').text(output_roubles(data.sum));
		$resultArea.find('[data-percent]').text(data.percent);
		$resultArea.find('[data-initial-percent]').text(data.initialPercent);
		$resultArea.find('[data-initial-payment]').text(output_roubles(data.sumWithInitialPayment));
		$resultArea.find('[data-loan-term]').text(output_wordform(data.loanTerm, ['месяц', 'месяца', 'месяцев']));

		$container.find('input[data-initial-percent]').val(data.initialPercent);
		$container.find('input[data-initial-payment]').val(data.sumWithInitialPayment);
		$container.find('input[data-term]').val(data.loanTerm);
	}
}

$(document).ready(function () {
	$('#modal-leasing').on('show.bs.modal', function () {
		const $leasingCalc = $('#leasing-calculator');
		if ($leasingCalc.length) {
			VGLeasingCalculator.init($leasingCalc);
		}
	});

	const $serviceLeasing = $('#service-leasing');
	if ($serviceLeasing.length) {
		const $leasingCalc = $('#leasing-calculator');
		if ($leasingCalc.length) {
			VGLeasingCalculator.init($leasingCalc);
		}
	}
});
